import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-bg-secondary border-t border-[#222] pt-24 pb-12 px-6 text-center" data-id="element-19">
      <div className="max-w-4xl mx-auto" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-center" data-id="element-21">
          <img src="https://cdn.magicpatterns.com/uploads/tm4d4ud82zMqryLRAB6zRC/BramalProject_logo.svg" alt="BRAMAL PROJECT s.r.o." className="w-full max-w-[200px] mb-12 opacity-80" data-id="element-22" />

          <h2 className="text-2xl md:text-3xl font-serif text-white mb-4 tracking-wide" data-id="element-23">
            {t('footer.tagline')}
          </h2>

          <p className="text-gray-400 font-light mb-12 max-w-2xl" data-id="element-24">
            {t('footer.contactText1')}
            <br data-id="element-25" />
            {t('footer.contactText2')}
          </p>

          {/* Contact info */}
          <div className="mb-12 text-gray-300" data-id="element-26">
            <p className="font-serif text-xl text-white mb-3" data-id="element-27">
              {t('footer.contactTitle')}
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6 text-sm" data-id="element-28">
              <a href="mailto:pavlik@bramal.cz" className="text-gold hover:text-gold-light transition-colors" data-id="element-29">
                pavlik@bramal.cz
              </a>
              <span className="hidden sm:inline text-gray-600" data-id="element-30">·</span>
              <a href="tel:+420602304915" className="text-gold hover:text-gold-light transition-colors" data-id="element-31">
                +420 602 304 915
              </a>
            </div>
          </div>

          <a href="http://www.svatyvaclav.living" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 border border-gold text-gold hover:bg-gold hover:text-bg-primary transition-all duration-300 uppercase tracking-widest text-sm mb-24" data-id="element-32">
            www.svatyvaclav.living
          </a>

          <div className="w-full h-px bg-[#222] mb-8" data-id="element-33"></div>

          <p className="text-xs text-gray-600 uppercase tracking-wider" data-id="element-34">
            {t('footer.copyright', {
            year: new Date().getFullYear().toString()
          })}
          </p>
        </motion.div>
      </div>
    </footer>;
}